import { typographyResponsive } from "../../styles/utils/typography.module";
export const MuiAvatarTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.regular")), { width: dt.size.xLarge3, height: dt.size.xLarge3, color: dt.color.onPrimary.key, backgroundColor: dt.color.palette.neutrals[50], ".PixelIcon": {
                    width: dt.icon.size.medium,
                    height: dt.icon.size.medium,
                    backgroundColor: dt.color.onPrimary.key,
                } }),
        },
    };
};
